import { AuthToken, UserDetails } from "models";
import { Preferences } from "@capacitor/preferences";
const TOKEN_CONST = "zero8_fcm_token";

const StorageLib = () => {
  const key = "za.co.zeroeight.app";
  const darkMode = key + "_darkmode";
  const setDarkMode = async (val: boolean) => {
    await Preferences.set({
      key: darkMode,
      value: val === true ? "enabled" : "disabled",
    });
  };
  const getDarkMode = async () => {
    const res = await Preferences.get({
      key: darkMode,
    });
    return res.value;
  };

  const setLogin = async (e: UserDetails) => {
    await Preferences.set({
      key: key,
      value: JSON.stringify(e),
    });
  };

  const getLogin = async (): Promise<UserDetails | null> => {
    const { value } = await Preferences.get({
      key: key,
    });
    if (value != null) {
      return JSON.parse(value);
    } else return null;
  };

  const removeLogin = async () => {
    await Preferences.remove({ key: key });
  };

  const setFcmToken = async (token: string) => {
    await Preferences.set({
      key: TOKEN_CONST,
      value: token,
    });
  };
  const getFcmToken = async () => {
    const res = await Preferences.get({
      key: TOKEN_CONST,
    });
    return res.value;
  };
  const removeFcmToken = async () => {
    await Preferences.remove({
      key: TOKEN_CONST,
    });
  };

  return {
    setLogin,
    getLogin,
    removeLogin,
    setDarkMode,
    getDarkMode,
    removeFcmToken,
    getFcmToken,
    setFcmToken,
  };
};
const storageLib = StorageLib();
export { storageLib };
